export default {
  namespaced: true,
  state: {
    selected_task: {},
    priorities: [],
    statuses: [],
    selected_priorities: [1, 2, 3, 4, null],
    selected_statuses: [1, 2, 3, 5, 6, null],
    // Dashboard status filters
    personal_status_filters: [],
    assigned_status_filters: [],
    created_for_others_status_filters: [],
    tags: [],
  },
  mutations: {
    set_selected_task(state, payload) {
      // Add validation to catch invalid task objects
      if (payload && Object.keys(payload).length > 0 && !payload.id) {
        console.warn('[Vuex tasks] Setting selected_task with missing or invalid ID:', payload);
      }
      state.selected_task = payload;
    },
    set_priorities(state, payload) {
      state.priorities = [...payload];
    },
    set_statuses(state, payload) {
      state.statuses = [...payload];
    },
    set_selected_priorities(state, payload) {
      state.selected_priorities = [...payload];
    },
    set_selected_statuses(state, payload) {
      state.selected_statuses = [...payload];
    },
    set_personal_status_filters(state, payload) {
      state.personal_status_filters = [...payload];
    },
    set_assigned_status_filters(state, payload) {
      state.assigned_status_filters = [...payload];
    },
    set_created_for_others_status_filters(state, payload) {
      state.created_for_others_status_filters = [...payload];
    },
    SET_TAGS(state, p) {
      state.tags = [...p];
    },
  },
  getters: {
    get_selected_task: (state) => state.selected_task,
    get_priorities: (state) => state.priorities,
    get_statuses: (state) => state.statuses,
    get_selected_priorities: (state) => state.selected_priorities,
    get_selected_statuses: (state) => state.selected_statuses,
    get_personal_status_filters: (state) => state.personal_status_filters,
    get_assigned_status_filters: (state) => state.assigned_status_filters,
    get_created_for_others_status_filters: (state) => state.created_for_others_status_filters,
    getTags: (state) => state.tags,
  },
  actions: {
    set_selected_task({ commit }, payload) {
      commit("set_selected_task", payload);
    },
    set_priorities({ commit }, payload) {
      commit("set_priorities", payload);
    },
    set_statuses({ commit }, payload) {
      commit("set_statuses", payload);
    },
    set_selected_priorities({ commit }, payload) {
      commit("set_selected_priorities", payload);
    },
    set_selected_statuses({ commit }, payload) {
      commit("set_selected_statuses", payload);
    },
    set_personal_status_filters({ commit }, payload) {
      commit("set_personal_status_filters", payload);
    },
    set_assigned_status_filters({ commit }, payload) {
      commit("set_assigned_status_filters", payload);
    },
    set_created_for_others_status_filters({ commit }, payload) {
      commit("set_created_for_others_status_filters", payload);
    },
    setTags({ commit }, p) {
      commit("SET_TAGS", p);
    },
  },
};
